import axios from 'axios';
import accessTokenRequest from '@/utils/custom-axios';

const baseApiUrl = `${process.env.VUE_APP_API}/messages`;

export const MessageService = {
  generatePatientHeaders(patientToken) {
    return {
      Authorization: `Token ${patientToken}`,
    };
  },

  getMessagesCombined(lasttimestamp, token) {
    return axios.get(
      `${baseApiUrl}/combined`,
      {
        params: {lasttimestamp: `${lasttimestamp}`},
        headers: this.generatePatientHeaders(token)
      },
    )
  },

  sendMessage(message, token, clientRefId) {
    return axios.post(
      `${baseApiUrl}/send`,
      {
        message: message,
        clientRefId: clientRefId,
      },
      {
        headers: this.generatePatientHeaders(token)
      }
    )
  },

  uploadAttachment(file, token) {
    return axios.post(
      `${baseApiUrl}/attachment`,
      file,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...this.generatePatientHeaders(token),
        },
      },
    );
  },

  getAttachment(uploadId, token) {
    return axios.get(
      `${baseApiUrl}/attachment?uploadid=${uploadId}`,
      {
        headers: this.generatePatientHeaders(token),
      },
    );
  },

  getOrderMessage(orderid, lasttimestamp) {
    return accessTokenRequest.get(
      `${baseApiUrl}/ordermessages/${orderid}`,
      {
        params: {lasttimestamp: `${lasttimestamp}`},
      },
    );
  },

  sendOrderMessage(orderid, message, clientRefId) {
    return accessTokenRequest.post(
      `${baseApiUrl}/ordermessages/${orderid}`,
      {
        msg: message,
        clientRefId: clientRefId,
      },
    )
  },

  sendOrderAttachmentMessage(orderid, file) {
    return accessTokenRequest.post(
      `${baseApiUrl}/ordermessages/${orderid}/attachment`,
      file,
    );
  },

  getOrderAttachmentFile(orderid, uploadid) {
    return accessTokenRequest.get(
      `${baseApiUrl}/ordermessages/${orderid}/file/${uploadid}`,
    );
  },
};
